/**
 * Locale utility for mapping i18n language codes to Intl locale codes.
 */

/**
 * Maps i18n language codes to full locale codes for Intl APIs.
 */
const LOCALE_MAP: Record<string, string> = {
  en: 'en-US',
  it: 'it-IT',
};

/**
 * Get the Intl-compatible locale from i18n language.
 * @param lang - The i18n language code (e.g., 'en', 'it')
 * @returns The full Intl locale code (e.g., 'en-US', 'it-IT')
 */
export function getLocale(lang: string): string {
  return LOCALE_MAP[lang] || LOCALE_MAP['en'];
}
